<div class="line-xs" id="fileExplorer">
  <div style="overflow-x: hidden">
    <div class="file-explorer flex-container">
        <div class="file-explorer outline search-bar">
            <div class="file-explorer search input-group transparent col-xs-12">
                <span class="file-explorer input-group-addon trailing-icon">
                    <span class="xsight-body4 hd-icon hd-icon-search icon-sm"></span>
                </span>
                <form class="file-search-form">
                    <input id="fileSearch" autocomplete="off" type="text"
                        class="file-explorer form-control form-search adjust-on-focus-overlay"
                        (focus)="state.onFocus()"
                        (change)="onChange()"
                        (keypress)="searchKeypress($event)"
                        placeholder="{{ 'fileExplorer_SearchFieldPlaceholder_Caption' | xsI18n  }}"
                        [(ngModel)]="state.searchText"
                        [ngModelOptions]="{ standalone: true }"
                        [attr.disabled]="searchInProgress ? '' : null">
                </form>
                <span class="input-group-btn">
                    <div id="searchText" class="file-explorer btn btn-link right-buffer-sm ng-binding ng-scope"
                        [attr.disabled]="state.searchButtonDisabled() ? '' : null"
                        (click)="state.onSearchButton()">
                        <span *ngIf="!state.hideSearchSpinner()"
                            class="fa fa-spinner fa-pulse fa-fw"></span>
                        {{state.searchButtonText}}
                    </div>
                </span>
            </div>
        </div>

      <div class="file-explorer outline" style="overflow-x: hidden">
        <div class="file-explorer table-container" id="tablebreadcrumb">
            <div class="display-table fill">
                <div *ngFor="let breadCrumbNode of state.breadCrumbNodes; last as isLast" class="file-explorer trail-cell">
                    <span hd-ellipsis-text one-time="true"
                        (click)="state.exploreTo(breadCrumbNode)" class="breadcrumb-title">{{ breadCrumbNode.title }}</span>
                    <span *ngIf="!isLast && state.breadCrumbNodes.length > 1"
                        class="fa fa-angle-right breadcrumb-icon"></span>
                </div>
            </div>
        </div>
        <div class="file-explorer table-container" id="tableheader">
            <div class="display-table fill">
                <div class="display-table-cell no-gutter file-explorer heading-cell tree-node cell-left"
                    id="fileNameHeader">{{'fileExplorer_Filename' | xsI18n }}</div>
                <div class="display-table-cell no-gutter file-explorer heading-cell tree-node cell-right file-size">
                    {{'fileExplorer_Size' | xsI18n }}</div>
                <div class="display-table-cell no-gutter file-explorer heading-cell tree-node cell-right file-type">
                    {{'fileExplorer_Type' | xsI18n }}</div>
                <div class="display-table-cell no-gutter file-explorer heading-cell tree-node cell-right file-modified-header">
                    {{'fileExplorer_Date' | xsI18n }}</div>
            </div>
        </div>
        <div id="filetable" (scroll)="onScroll()" class="content soti-scroll-bar-y">
        </div>
      </div>
      <app-file-manager-action-bar class="footer"
          *ngIf="isActionBarAvailableByToggle()"
          [selectedTreeNodes]="state.selectedTreeNodes">
      </app-file-manager-action-bar>
    </div>
  </div>
</div>
